import { render, staticRenderFns } from "./RepositorioPage.vue?vue&type=template&id=4f9c9e0e"
import script from "./RepositorioPage.js?vue&type=script&lang=js&external"
export * from "./RepositorioPage.js?vue&type=script&lang=js&external"
import style0 from "./RepositorioPage.vue?vue&type=style&index=0&id=4f9c9e0e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports